import Button from "../../../Button/Button";
import "./documentLinkComment.css";
import addDocument from "../../plus.png";
import { useState } from "react";
import link from "../../link.png";
import document from "../../dokument.png";
import { useGlobalContext } from "../../../Context/Context";

const DocumentLinkComment = ({
  itemComment,
  setItemComment,
  commentImageActive,
}) => {
  const { setOpenAddLink } = useGlobalContext();
  const { typeButton, letterSize, boldItalic, fontSize, fontStyle } =
    useGlobalContext();

  // isCOmmenting === true -> dodavanje komentara
  // attachModalActive === undefined => dodavanje stavke
  // !isCommenting -> citanje stavke
  // isCommenting === undefined -> citanje komentara

  const maxFileNameLength = 40;
  const [openLink, setOpenLink] = useState(false);

  const handleInputLink = (e) => {
    setItemComment({ ...itemComment, link: e.currentTarget.value });
  };

  const handleConvertText = (text) => {
    console.log(text);
    if (letterSize === undefined || letterSize === null) {
      return text;
    }
    if (letterSize === 0) {
      return text.toUpperCase();
    }
    if (letterSize === 1) {
      return text[0].toUpperCase() + text.slice(1).toLowerCase();
    }
    if (letterSize === 2) {
      return text.toLowerCase();
    }
  };
  const handleInputDocument = (e) => {
    const reader = new FileReader();
    reader.addEventListener("load", () =>
      setItemComment({
        ...itemComment,
        document: { data: reader.result, name: e.target.files[0].name },
      })
    );
    reader.readAsDataURL(e.target.files[0]);
  };
  console.log(itemComment);
  const handleOpenLink = () => {
    setOpenLink(!openLink);
  };

  return (
    <div className="image-document-comment-wrapper">
      {itemComment.document !== "" && (
        <a
          className="download-link"
          target="_blank"
          href={itemComment.document?.data}
        >
          <img src={document} alt="" />
          {itemComment.document?.name?.length > maxFileNameLength
            ? `${itemComment.document.name.slice(0, maxFileNameLength)}...`
            : itemComment.document.name}
        </a>
      )}
      <span
        className={
          "image-modal-span " +
          `font-size-${parseInt(
            fontSize === undefined || fontSize === null ? 0 : fontSize / 3
          )}` +
          ` font-style-${parseInt(
            fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3
          )}`
        }
        style={
          boldItalic.find((element) => parseInt(element) === 2) !== undefined
            ? {
                fontWeight: "normal",
                fontStyle: "normal",
              }
            : boldItalic.find((element) => parseInt(element) === 1) !==
                undefined &&
              boldItalic.find((element) => parseInt(element) === 0) !==
                undefined
            ? {
                fontWeight: "bold",
                fontStyle: "italic",
              }
            : boldItalic.find((element) => parseInt(element) === 0) !==
              undefined
            ? {
                fontStyle: "italic",
              }
            : boldItalic.find((element) => parseInt(element) === 1) !==
              undefined
            ? {
                fontWeight: "bold",
              }
            : {
                fontWeight: "normal",
                fontStyle: "normal",
              }
        }
      >
        {handleConvertText("* Dozvoljeno 1 dokument i 1 link")}
      </span>{" "}
      {/* prevod jezika */}
      <span
        className={
          "image-modal-span " +
          `font-size-${parseInt(
            fontSize === undefined || fontSize === null ? 0 : fontSize / 3
          )}` +
          ` font-style-${parseInt(
            fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3
          )}`
        }
        style={
          boldItalic.find((element) => parseInt(element) === 2) !== undefined
            ? {
                fontWeight: "normal",
                fontStyle: "normal",
              }
            : boldItalic.find((element) => parseInt(element) === 1) !==
                undefined &&
              boldItalic.find((element) => parseInt(element) === 0) !==
                undefined
            ? {
                fontWeight: "bold",
                fontStyle: "italic",
              }
            : boldItalic.find((element) => parseInt(element) === 0) !==
              undefined
            ? {
                fontStyle: "italic",
              }
            : boldItalic.find((element) => parseInt(element) === 1) !==
              undefined
            ? {
                fontWeight: "bold",
              }
            : {
                fontWeight: "normal",
                fontStyle: "normal",
              }
        }
      >
        {handleConvertText("* Dozvoljeni formati: PDF, DOCX...")}
        {/*prevod jezika*/}
      </span>
      <span
        className={
          "image-modal-span " +
          `font-size-${parseInt(
            fontSize === undefined || fontSize === null ? 0 : fontSize / 3
          )}` +
          ` font-style-${parseInt(
            fontStyle === undefined || fontStyle === null ? 0 : fontStyle / 3
          )}`
        }
        style={
          boldItalic.find((element) => parseInt(element) === 2) !== undefined
            ? {
                fontWeight: "normal",
                fontStyle: "normal",
              }
            : boldItalic.find((element) => parseInt(element) === 1) !==
                undefined &&
              boldItalic.find((element) => parseInt(element) === 0) !==
                undefined
            ? {
                fontWeight: "bold",
                fontStyle: "italic",
              }
            : boldItalic.find((element) => parseInt(element) === 0) !==
              undefined
            ? {
                fontStyle: "italic",
              }
            : boldItalic.find((element) => parseInt(element) === 1) !==
              undefined
            ? {
                fontWeight: "bold",
              }
            : {
                fontWeight: "normal",
                fontStyle: "normal",
              }
        }
      >
        {handleConvertText("* Link se dodaje kopiranjem")}
      </span>
      {/*prvod jezika*/}
      <div className="wrapper-link-button">
        {openLink ? (
          <input
            defaultValue={itemComment.link}
            type="text"
            onChange={handleInputLink}
          />
        ) : (
          <span
            className={
              `font-size-${parseInt(
                fontSize === undefined || fontSize === null ? 0 : fontSize / 3
              )}` +
              ` font-style-${parseInt(
                fontStyle === undefined || fontStyle === null
                  ? 0
                  : fontStyle / 3
              )}`
            }
            style={
              boldItalic.find((element) => parseInt(element) === 2) !==
              undefined
                ? {
                    fontWeight: "normal",
                    fontStyle: "normal",
                  }
                : boldItalic.find((element) => parseInt(element) === 1) !==
                    undefined &&
                  boldItalic.find((element) => parseInt(element) === 0) !==
                    undefined
                ? {
                    fontWeight: "bold",
                    fontStyle: "italic",
                  }
                : boldItalic.find((element) => parseInt(element) === 0) !==
                  undefined
                ? {
                    fontStyle: "italic",
                  }
                : boldItalic.find((element) => parseInt(element) === 1) !==
                  undefined
                ? {
                    fontWeight: "bold",
                  }
                : {
                    fontWeight: "normal",
                    fontStyle: "normal",
                  }
            }
          >
            {handleConvertText(itemComment.link)}
          </span>
        )}
        <div className="document-link-add">
          <div className="document-add">
            <label className="button-image-document-link" htmlFor="file-upload">
              <img src={addDocument} alt="" className="" />
              <img src={document} alt="" className="" />
            </label>
            <input
              accept="application/*"
              id="file-upload"
              type="file"
              onChange={handleInputDocument}
            />
          </div>
          <div className="document-add" onClick={handleOpenLink}>
            <Button
              active={itemComment.link === "" && openLink}
              activation={true}
              typeButton={typeButton}
            >
              <div className="button-image-document-link">
                <img src={addDocument} alt="" className="" />
                <img src={link} alt="" className="" />
              </div>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentLinkComment;
